import React from 'react';
import Joi from 'joi';
import _ from 'lodash';

import { updateReport } from '../../services/projectService';
import { getErrorMessage } from '../../utils/utilities';
import { CoverDataItem, Project } from '../../utils/models';

import Conditional from '../common/conditional';
import Form from '../common/form';
import LoadingBadge from '../themed/loading-badge';

import withRouter from '../hoc/withRouter';
import toastService from '../../services/toastService';
import withProjectDetails from '../hoc/withProjectDetails';

class ProjectCoverDataUpdate extends Form {
    state = {
		data: {
			scope: '',
            equipmentTag: '',
            equipmentDescription: '',
            documentNumber: '',
            module: '',
		},
		errors: {},
		loading: false,
		progress: 0,
	};
    
    schema = {
		scope: Joi.string().min(3).required().label('Scope'),
		equipmentTag: Joi.string().min(3).required().label('Equipment Tag'),
		equipmentDescription: Joi.string().min(3).required().label('Equipment Description'),
        documentNumber: Joi.string().required().label("Document Number"),
        module: Joi.alternatives().try(Joi.object({
			label: Joi.string().required(),
			value: Joi.string().required(),
			__isNew__: Joi.boolean().optional(),
		}), Joi.string().min(5)).required().label('Module'),
	};

    async componentDidMount() {
        await this.props.fetchProjectDetails();
        const initialData =  _.pick(this.props.projectDetails, ['scope', 'equipmentTag', 'equipmentDescription', 'module', 'documentNumber']);

        initialData.module = {
            label: initialData.module,
            value: initialData.module
        };

        this.setState({ data: initialData });
    };


    getApiData = () => {
        const apiData = { ..._.omit(this.props.projectDetails, [
            'viewersId',
            'facility',
            'comment',
            'organisation',
            'inspectedItemIDs',
            'viewersName',
            'review']), ...this.state.data 
        };

        apiData.module = (apiData.module as unknown as CoverDataItem).value;

        return apiData;
    };

    getModules = () => {
        const project: Project = this.props.projectDetails;
        if (project) {
            return project.facility.modules.map((module) => ({ label: module.name, value: module.name }));
        }

        return [];
    };

    handleCreateModule = (module: string) => {
        this.setState({
            data: { 
                ...this.state.data,
                module: { label: module, value: module },
            }
        });
    };

    postData = async () => {
        await updateReport(this.props.projectDetails._id, this.getApiData(), this.handleProgressChange);
        window.location.reload();
    };

    doSubmit = (): void => {
		toastService.promise(this.postData(), {
			loading: 'Updating Project Cover Data',
			success: () => 'Project Cover Data Updated',
			error: getErrorMessage,
		});
	};

    render() { 
        return ( 
            <div className='p-3'>
                <Conditional isVisible={this.props.isFetching}>
                    <LoadingBadge message='Loading...' /> 
                </Conditional>

                <Conditional isVisible={!this.props.isFetching}>
                    <form  onSubmit={this.handleSubmit}>
                        <div className="container">
                            <div className="row">
                                <div className="col">
                                    {this.renderInput({
                                        type: 'text',
                                        name: 'scope',
                                        label: 'Scope',
                                        placeholder: 'Enter Project Scope',
                                    })}
                                </div>
                                <div className="col">
                                    {this.renderInput({
                                        type: 'text',
                                        name: 'equipmentTag',
                                        label: 'Equipment Tag',
                                        placeholder: 'Enter Project Equipment Tag',
                                    })}
                                </div>
                            </div>

                            <div className="divider my-4"></div>
                           
                           <div className="row">
                            <div className="col">
                                {this.renderInput({
                                    type: 'text',
                                    name: 'equipmentDescription',
                                    label: 'Equipment Description',
                                    placeholder: 'Enter Project Equipment Description',
                                })}
                            </div>
                            <div className="col">
                                {this.renderInput({
                                    type: 'text',
                                    name: 'documentNumber',
                                    label: 'Document Number',
                                    placeholder: 'Enter Project Document Number',
                                })}
                            </div>
                           </div>

                            <div className="divider my-4"></div>

                            {this.renderCreatableMultiselect({
                                closeMenuOnSelect: true,
                                options: this.getModules(),
                                name: 'module',
                                placeholder: 'Enter Module',
                                label: 'Module',
                                onCreateOption: this.handleCreateModule,
                                isMulti: false,
                            })}

                            <div className="divider mt-4"></div>

                            <div className="d-flex justify-content-end">
                                {this.renderButton('Save Changes')}
                            </div>
                        </div>
                    </form>
                </Conditional>
            </div>
         );
    }
}
 
export default withProjectDetails(withRouter(ProjectCoverDataUpdate))